// extracted by mini-css-extract-plugin
module.exports = {"main":"main_main__2W-l3","textOrange":"main_textOrange__2keLn","responsiveText":"main_responsiveText__N2yo2"};